import store from '../stores/app.store';

const auth = {
  async checkEmail(email) {
    const company = store.state.company;
    if(!company) {
      return false;
    } else {
      let allowedEmails = company['allowedEmails'];
      const isAllowed = this.loggedIn = allowedEmails.includes(email)
      return isAllowed;
    }
  },
  async companyExists() {
    return !!store.state.company;
  }
};

export default auth;


// WEBPACK FOOTER //
// ./src/services/auth.service.js